import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=8bd7fc5e&"
import script from "./Offer.vue?vue&type=script&lang=js&"
export * from "./Offer.vue?vue&type=script&lang=js&"
import style0 from "./Offer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sebastian/Projekte/CD-Systeme/nextgenkonfi/konfiguratornextgen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bd7fc5e')) {
      api.createRecord('8bd7fc5e', component.options)
    } else {
      api.reload('8bd7fc5e', component.options)
    }
    module.hot.accept("./Offer.vue?vue&type=template&id=8bd7fc5e&", function () {
      api.rerender('8bd7fc5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Offer.vue"
export default component.exports